module.exports = __webpack_public_path__ + "static/media/revert.a43b2d99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/revert.svg
// module id = 1578
// module chunks = 1